// extracted by mini-css-extract-plugin
module.exports = {"skillsBlock":"Skills_skillsBlock__1BgMD","skillsContainer":"Skills_skillsContainer__3DvZo","skills":"Skills_skills__1nWyb"};